export type FamilyGroupManagementModel = {
  FamilyGroup: string,
  ProductType: string,
  //SubCategory: string,
}

export const initialFamilyGroupManagementModel: FamilyGroupManagementModel = {
  ProductType: "",
  FamilyGroup: "",
  //SubCategory: ""
}